import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { routes } from './routes'

const PageContent = () => {
    return (
        <div className='page-content'>
            <Routes>
                {routes.map((item) => {
                    return (
                        <Route
                            path={item?.path}
                            element={<item.element />}
                        />
                    )
                })}
            </Routes>
        </div>
    )
}

export default PageContent